import { Container, SubTitle, InfoText, MoneyTextMask } from './styles'

export default function Member ({ data: member }) {
  return (
    <Container>
      <SubTitle style={{justifySelf: 'flex-start', textAlign: 'left'}}>
        {member.name}
      </SubTitle>
      <InfoText>
        {member.totalSchedules}
      </InfoText>
      <MoneyTextMask value={member.totalSpent} style={{justifySelf: 'flex-end'}}/>
    </Container>
  )
}
